/*
 * @Author: Ygm
 * @Date: 2024-04-17 09:16:06
 * @LastEditors: Ygm
 * @LastEditTime: 2025-08-06 16:39:27
 * @Description: 与android交互方法
 */

/**
 * @description 直接调用安卓方法新开页面
 * @param url {string} 跳转地址
 */
const toWebActivity = url => {
  window.setupWebViewJavascriptBridge(bridge => {
    const newPageUrl = window.location.origin + url
    bridge.callHandler('toWebActivity', encodeURIComponent(newPageUrl))
  })
}

/**
 * @description 通知H5外壳新开页面跳转
 * @param type {string} 平台类型
 * @param linkUrl {string} 页面链接
 * @param openType {string} 打开方式
 */
const onJumpLink = (type = '', linkUrl = '', openType = '_blank') => {
  switch (type) {
    case 'APP':
      const params = {
        type: 'openUrl',
        data: linkUrl + '&client=APP'
      }

      window.parent && window.parent.postMessage(params, window.location.ancestorOrigins[0])
      window.setupWebViewJavascriptBridge(bridge => {
        bridge.callHandler('toWebActivity', encodeURIComponent(linkUrl + '&client=APP'))
      })
      break
    default:
      window.name = '/base/main' // 使用浏览器路径作为 windowName
      window.open(linkUrl, openType)
  }
}

/**
 * @description 通知安卓关闭页面
 * @param type {string} 平台类型
 */
const onClosePage = (type = '') => {
  switch (type) {
    case 'APP':
      window.setupWebViewJavascriptBridge(bridge => {
        bridge.callHandler('finishPage')
      })
      break
    default:
      window.open('about:blank', '_self').close()
  }
}

/**
 * @description 通知安卓调用对应的方法
 * @param type {string} 安卓页面类型 （notice:公文  task:任务）
 * @param methods {string} 方法名
 */
const noticeAndroidsAction = (type, methods = '') => {
  const methodsStr = type + '-' + methods
  window.setupWebViewJavascriptBridge(bridge => {
    bridge.callHandler('callWebAction', methodsStr)
  })
}

/**
 * @description 调用安卓预览
 * @param fileParams {object} 文件相关信息
 */
const androidFilePreview = fileParams => {
  window.setupWebViewJavascriptBridge(bridge => {
    bridge.callHandler('fileReview', JSON.stringify(fileParams))
  })
}

/**
 * @description 调用安卓导出
 * @param stream {blob} 文件流对象
 * @param fileName {string} 文件名
 */
const androidExport = (stream, fileName) => {
  // 将文件名中的非法字符串转为'_'
  fileName = fileName.replace(/[\\/:*?"<>|]/g, '_')
  // 将文件流转换为 Base64 字符串
  const reader = new FileReader()
  reader.readAsDataURL(stream)
  reader.onload = function () {
    const base64String = reader.result
    const params = {
      fileName,
      type: 'export',
      data: base64String
    }
    window.parent && window.parent.postMessage(params, window.location.ancestorOrigins[0])
  }
}

/**
 * *  打开或关闭Tabbar
 */
const tabbarVisChange = isShow => {
  const params = {
    type: 'tabbar',
    data: isShow
  }
  window.parent && window.parent.postMessage(params, window.location.ancestorOrigins[0])
}

/**
 * @description 通知安卓打开IM对话框
 * @param params {object} 参数
 */
const noticeOpenIm = (params = {}) => {
  window.setupWebViewJavascriptBridge(bridge => {
    bridge.callHandler('toSendMsg', JSON.stringify(params))
  })
}

export {
  onJumpLink,
  onClosePage,
  toWebActivity,
  noticeAndroidsAction,
  androidFilePreview,
  androidExport,
  tabbarVisChange,
  noticeOpenIm
}



// WEBPACK FOOTER //
// ./src/utils/toAndroid.js